import React from 'react';
import PropTypes from 'prop-types';
const loadFile = name => require(`../assets/svgs/${name}.svg`);

const Svg = ({
  name,
  size = 20,
  height,
  width,
  style,
  color,
  ...rest
}) => {
  const w = width || size;
  const h = height || size;

  loadFile(name);

  return (
    <svg className={style} width={w} height={h} {...rest}>
      <use xlinkHref={`#${name}`} fill={ color ? color : '' } />
    </svg>
  );
};

Svg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  style: PropTypes.string,
  width: PropTypes.number,
};

Svg.displayName = 'Svg';

export default Svg;



// WEBPACK FOOTER //
// ./src/components/Svg.js